const dashboardNameByRoute = {
  'dashboard1/control': 'CIEPS',
  'dashboard2/control': 'Goca'
}

export const getDashboardNameByRoute = (route) => {
  if(dashboardNameByRoute.hasOwnProperty(route.toLowerCase())) {
    return dashboardNameByRoute[route.toLowerCase()]
  } 
}